import React from 'react';
import ReactDOM from 'react-dom';
import { formatFileSize } from '../utils/formatFileSize';

/**
 * StorageLimitDialog - Blocking dialog shown when a user hits a plan limit.
 * limitType: 'storage' | 'reflections' | 'export' | 'sharing'
 */
function StorageLimitDialog({ show, storageStatus, limitType = 'storage', onClose, onUpgrade }) {
  if (!show) return null;

  const handleUpgrade = () => {
    onClose();
    if (onUpgrade) {
      onUpgrade();
    } else {
      window.history.pushState({}, '', '?page=settings&tab=subscription');
      window.dispatchEvent(new PopStateEvent('popstate'));
    }
  };

  let title, message;

  if (limitType === 'reflections') {
    title = 'Reflection Limit Reached';
    message = (
      <>
        You've used all <strong>{storageStatus?.reflectionLimit}</strong> reflections included in the{' '}
        <strong>{storageStatus?.planName || 'Free'}</strong> plan.
        <br /><br />
        Upgrade to record unlimited memories.
      </>
    );
  } else if (limitType === 'export') {
    title = 'Export Not Available';
    message = (
      <>
        Downloading and exporting reflections is not available on the{' '}
        <strong>{storageStatus?.planName || 'Free'}</strong> plan.
        <br /><br />
        Upgrade to Personal or Family to download your archive.
      </>
    );
  } else if (limitType === 'sharing') {
    title = 'Sharing Not Available';
    message = (
      <>
        Sending sharing invitations is not available on the{' '}
        <strong>{storageStatus?.planName || 'Free'}</strong> plan.
        <br /><br />
        Upgrade to Personal or Family to share your reflections.
      </>
    );
  } else {
    title = 'Storage Full';
    message = storageStatus ? (
      <>
        You've used <strong>{formatFileSize(storageStatus.totalUsed)}</strong> of your{' '}
        <strong>{formatFileSize(storageStatus.limit)}</strong> storage
        {storageStatus.planName && <> on the <strong>{storageStatus.planName}</strong> plan</>}.
        <br /><br />
        Your existing reflections are safe and you can still view them, but you won't be
        able to add new recordings until you free up space or upgrade your plan.
      </>
    ) : (
      <>
        You've reached your storage limit. Your existing reflections are safe, but you
        won't be able to add new recordings until you free up space or upgrade your plan.
      </>
    );
  }

  return ReactDOM.createPortal(
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()} style={{ maxWidth: '480px', textAlign: 'center' }}>
        <div className="modal-header">
          <h3>{title}</h3>
          <button onClick={onClose}>&#10005;</button>
        </div>
        <div style={{ padding: '1.5rem' }}>
          <p style={{ marginBottom: '1.5rem', lineHeight: 1.6 }}>{message}</p>
          <div style={{ display: 'flex', gap: '0.75rem', justifyContent: 'center' }}>
            <button className="btn-save" onClick={handleUpgrade}>
              Upgrade Plan
            </button>
            <button
              onClick={onClose}
              style={{
                padding: '0.5rem 1.25rem', border: '1px solid #ddd',
                borderRadius: '6px', background: 'none', cursor: 'pointer',
              }}
            >
              Not now
            </button>
          </div>
        </div>
      </div>
    </div>,
    document.body
  );
}

export default StorageLimitDialog;
